import axios from "axios";
import { getRequestData } from "./utils";
import store from "../store";
import {aes_256_encrypt, aes_256_decrypt} from "../components/encyrption/aes_256"
import { getOrCreateEncryptionMaterial } from "../components/encyrption/secret_key_store"
import jwt_decode from "jwt-decode";
import { Buffer } from "buffer";

const instance = axios.create({});
instance.defaults.withCredentials = false;

function getEncryptionFlag() {
  const envFlag = process.env.VUE_APP_API_ENCRYPTION;
  if (envFlag === 'true' || envFlag === '1') return true;
  if (envFlag === 'false' || envFlag === '0') return false;
  return false;
}
async function encryptPayload(api,payload)
{
  const { cryptoKey, sessionId } = await getOrCreateEncryptionMaterial()
  let request_payload={}
  // if(api=="generateToken" || api == "generateTokenOverride")
  // {
    request_payload= {
        "session_id": sessionId
    };
  // }
  if (payload!=null){
    request_payload["payload"] = await aes_256_encrypt(cryptoKey,payload);
}
return request_payload;
}
async function decryptResponsePayload(response_payload)
{
    const { cryptoKey } = await getOrCreateEncryptionMaterial()
    response_payload.data = await aes_256_decrypt(cryptoKey,response_payload.data.payload)
    return response_payload
}
async function encryptParamsURL(param)
{
  const { cryptoKey } = await getOrCreateEncryptionMaterial()
  const encrypted = await aes_256_encrypt(cryptoKey,param)
  const request_param={"payload":encrypted}
  console.log(request_param);
  return encodeURIComponent(encrypted);
}
export default async function backendApi(api, data, headers = {}, method = "post",param={}, multipleParams = {}) {
  const request = getRequestData(api, data);
  //instance.defaults.timeout =10000;
  const body = request.body;
  let url = request.url;
  const baseURL = request.baseURL;
  instance.defaults.baseURL = baseURL;
  const shouldEncrypt = getEncryptionFlag()
  let encrypt_payload=body
  let encryptedRequest = null
  if(shouldEncrypt) {
    encryptedRequest = await encryptPayload(api,body)
    encrypt_payload = {}
    encrypt_payload['payload'] = encryptedRequest.payload
  }
  if(Object.keys(param).length !== 0){
    let index = 1;
    for (const key in param) {
      url = url.replace("param" + index, param[key]);
      index++;
    }
  }
  if(Object.keys(multipleParams).length !== 0){
    let index = 1;
    url+='?';
    for (const key in multipleParams) {
      if (multipleParams[key] !== "") { // Check if value is not empty
        if (index > 0) { // Add '&' before adding subsequent parameters
          url += '&';
        }
        url += key + '=' + encodeURIComponent(multipleParams[key]);
        index++;
      }}
  }
  else{
    let i = 1;
    for (const key in data) {
      url = url.replace("param" + i, data[key]);
      i++;
    }
  }
  if(shouldEncrypt && api!="generateToken" && api != "generateTokenOverride")
  {
  let param_url_split= url.split("?")
  let param_url=param_url_split[0]
  if(param_url_split.length>1)
  {
    let queryString=param_url_split[1]
    var pairs = queryString.split('&');
    var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
    param_url = param_url+"?"+"payload="+await encryptParamsURL(result)
  }
  url=param_url
}
  let header = headers;
  if(shouldEncrypt) {
    header['x-session-id'] = encryptedRequest.session_id;
  }
  if (api != "generateToken" && api != "refreshToken" && api != "getRmDetails" && api != "userLogin" && api != "generateTokenOverride") {
    let token = store.state.token;

    if (token && checkTokenValidity(token)) {
      let decodeToken;
      try {
        decodeToken = jwt_decode(token);
      } catch (e) {
        sessionStorage.removeItem('vuex')
        window.location.href = `${window.location.origin}/#/login`
        return Promise.reject(e);
      }
      header['Authorization'] = `Bearer ${store.state.token}`;
      if(decodeToken?.PAYLOAD?.externalReferenceId != ""){
      const customer_identifier = decodeToken.PAYLOAD.externalReferenceId;
      header['customer_identifier'] = customer_identifier;
      }
      if(sessionStorage.getItem('journey_id')){
      const journey_id = JSON.parse(sessionStorage.getItem('journey_id'));
      header['journey_id'] = journey_id;
      }
    } else {
      if(api != "getRmDetailsDIY"){
        sessionStorage.removeItem('vuex')
        window.location.href = `${window.location.origin}/#/login`  
      }
  }
}
  return wrap(method, { url, encrypt_payload, header })
    .then(async response => {
      if(shouldEncrypt)
      return await decryptResponsePayload(response);
      else
      return response
    })
    .catch(error => {
      console.log(api, "ERROR", error.response);
      console.log(error.response);

      // let msg=['Something went wrong, Please try again after some time ']
      // this.$router.push({ path: '/networkalert', query: {backUrl:'dashboard', msg: msg}});

      let data;
      if (error.response) {
        data = {
          "status": 'error',
          "data": error.response.data
        }
      } else {
        data = {
          "status": 'error'
        }
      }
      return data;
    });
}

const wrap = (method, { url, encrypt_payload, header }) => {
  if (method === "get") {
    // console.log(method)
    return instance.get(url, { headers: header })
  } else if (method === "post") {
    return instance.post(url, encrypt_payload, { headers: header })
  } else if (method === "put") {
    return instance.put(url, encrypt_payload, { headers: header })
  } else if (method === "delete") {
    return instance.delete(url, { headers: header })
  }
}
const checkTokenValidity = (token) => {
  let decodedToken = parseJwt(token)
  if (decodedToken && decodedToken['expires'] < Date.now() / 1000) {
    // token expired (session)
    console.log("expired");
    return false;
  } else {
    if (((decodedToken['expires'] - Date.now() / 1000) / 60) <= 1) {
      // token getting expired (have to refresh)
      console.log("refresh token");
      let data = {
        currentToken: token
      }
      backendApi("refreshToken", data)
        .then((resp) => {
          let accessToken = resp.data.data.newToken.access_token;
          store.commit('setToken', accessToken)
          return true;
        })
        .catch((error) => {
          console.log("refresh token failed")
          console.log(JSON.stringify(error));
        })
    }
    return true;
  }
}

function parseJwt(token) {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}
